export default __webpack_public_path__ + "static/media/CNo.71-1.d0851778.jpg";